var _defs, _path, _path2, _path3, _path4, _text, _g, _g2, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyus6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a00e8;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke: #000;\n      }\n\n      .cls-1, .cls-3, .cls-4, .cls-5 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 6px;\n      }\n\n      .cls-2 {\n        font-family: GothamRounded-Bold, 'Gotham Rounded';\n        font-size: 37px;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-3 {\n        fill: #e0ef4d;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.43,72.62H222.24c6.62,0,12,5.38,12,12v19.22H54.43v-19.22c0-6.62,5.38-12,12-12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.43,103.84H234.24v127.94c0,6.62-5.38,12-12,12H66.43c-6.62,0-12-5.38-12-12V103.84h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M255.81,34.28l-29.82,4.19c-2.51,.35-3.48,3.46-1.62,5.18l7.83,7.23-60.3,66.62-26.9-23.04c-3.68-3.15-9.19-2.83-12.47,.73l-38.6,41.84c-3.38,3.66-3.39,9.45,.24,12.87,1.74,1.64,3.96,2.45,6.17,2.45,2.42,0,4.84-.97,6.62-2.9l32.92-35.69,26.96,23.09c3.7,3.17,9.25,2.82,12.53-.8L245.44,63.09l6.96,6.43c1.86,1.72,4.88,.5,5.03-2.03l1.79-30.05c.11-1.89-1.54-3.41-3.41-3.15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.49,191.04c5.77-6.43,9.14-14.1,9.14-22.35,0-22.63-25.28-40.98-56.46-40.98s-56.46,18.35-56.46,40.98,25.28,40.98,56.46,40.98c10.18,0,19.73-1.97,27.98-5.39l25.63,2.03c1.66,.13,2.75-1.71,1.82-3.1l-8.12-12.17Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(49.8 183.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SELL"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 176.61,
    y1: 175.5,
    x2: 176.61,
    y2: 223.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 169.24,
    y: 181.09,
    width: 14.74,
    height: 35.55,
    rx: 4,
    ry: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 204.66,
    y1: 141.76,
    x2: 204.66,
    y2: 189.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 197.28,
    y: 147.35,
    width: 14.74,
    height: 35.55,
    rx: 4,
    ry: 4
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 70.13,
    y1: 88.58,
    x2: 70.13,
    y2: 88.58
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 101.45,
    y1: 88.58,
    x2: 101.45,
    y2: 88.58
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 85.79,
    y1: 88.58,
    x2: 85.79,
    y2: 88.58
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyus6);
export default __webpack_public_path__ + "static/media/whyus6.60fe1680cd4d7c135ecd94d3f517d8d3.svg";
export { ForwardRef as ReactComponent };